// components
import { Logo } from '@/components/atoms/Logo/Logo';

// mui
import { Box, Button, Link, Stack, Typography } from '@mui/material';

/**
 * CareReferralInfo renders the referral landing page info card.
 */
export const CareReferralInfo = ({
  onRegister,
  onSignIn,
}: CareReferralInfoProps) => {
  return (
    <Stack spacing={1}>
      <Typography variant='h2' sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
        Getting Started
      </Typography>
      <Typography
        variant='caption'
        sx={{ textAlign: { xs: 'center', sm: 'left' } }}
      >
        Our care concierge service supports SJP clients and their families with
        professional advice on understanding, finding and funding care.
      </Typography>
      <Typography variant='caption'>Your client will benefit from:</Typography>
      <Box component='ul' sx={{ m: 0, pl: 2.5 }}>
        <Typography component='li' variant='caption'>
          1:1 <strong>unlimited access</strong> to a{' '}
          <strong>dedicated care expert</strong>
        </Typography>
        <Typography component='li' variant='caption'>
          Comprehensive digital <strong>care assessment</strong>
        </Typography>
        <Typography component='li' variant='caption'>
          <strong>Expert</strong> search for the{' '}
          <strong>best care options</strong>
        </Typography>
        <Typography component='li' variant='caption'>
          Direct access to <strong>vetted, regulated care providers</strong>
        </Typography>
        <Typography component='li' variant='caption'>
          <strong>Bespoke consultation</strong> on{' '}
          <strong>non-regulated funding benefits eligiblity</strong>
        </Typography>
        <Typography component='li' variant='caption'>
          <strong>Practical help</strong> applying for funding benefits
        </Typography>
      </Box>
      <Stack
        sx={{
          gap: 2,
          paddingTop: 2,
        }}
      >
        <Button
          variant='contained'
          onClick={onRegister}
          aria-label='create-account'
        >
          Create Account
        </Button>
        <Typography
          variant='caption'
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
          }}
        >
          Already registered?{' '}
          <Link
            component='span'
            variant='caption'
            color='primary'
            onClick={onSignIn}
            sx={{
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            Sign in
          </Link>
        </Typography>
      </Stack>
    </Stack>
  );
};

// types
interface CareReferralInfoProps {
  onRegister: () => void;
  onSignIn: () => void;
}

CareReferralInfo.displayName = 'CareReferralInfo';

export default CareReferralInfo;
